export const environment = {
  production: true,
  hmr: false,
  disableSignalR: false,
  sandbox: false,
  requestTimeout: 60_000,
};
